
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import studyImg from "@/assets/img/study@2x.png";
import iconlike from "@/assets/img/RegistrationRed.png";
import iconnolike from "@/assets/img/Registration.png";
import MP4Img from "@/assets/img/Mp4@2x.png";
import Excel from "@/assets/img/Exel@2x.png";
import pdf from "@/assets/img/PDF@2x.png";
import word from "@/assets/img/word@2x.png";
import t from "@common/src/i18n/t";
const study = namespace("study");
const store = namespace("store");
const user = namespace("user");
@Component({})
export default class OnlineStudy extends Vue {
  @study.Action queryContentPage;
  @study.Action likeContent;
  @study.Action searchLearnContentSettingPage;
  @study.Action getLearnContentTextDetail;
  @study.Action queryLearnClassList;
  @study.Action signUp;
  @store.State storeData;
  @user.State userData;
  dayjs = dayjs;
  iconlike = iconlike;
  iconnolike = iconnolike;
  studyImg = studyImg;
  MP4Img = MP4Img;
  Excel = Excel;
  pdf = pdf;
  word = word;
  showPickingTips = false;
  remark = "";
  isWhitespace: Boolean = true;
  get searchTextResult() {
    return this.$route.query.search;
  }
  fixedFlag = true;
  fixedFlagFlase() {
    this.fixedFlag = false;
  }
  showDialog($event, item) {
    console.log("[ item ]", item);
    this.showPickingTips = true;
    if (item) {
      this.contentDetail = item;
    }
  }
  @Watch("searchText")
  searchTextWatch() {
    if (this.searchText === "") {
      this.searchFlag = false;
    }
  }
  get signUpBox() {
    return this.contentDetail.admissionExamination === "true" && !this.newsFlag && this.fixedFlag;
  }
  getImgSrc(item) {
    if (item.annexType === "docx") {
      return word;
    } else if (item.annexType === "xlsx") {
      return Excel;
    } else if (item.annexType === "pdf") {
      return pdf;
    } else {
      return MP4Img;
    }
  }
  filterKeyLight(text) {
    if (!this.searchText) return text;
    const result = text.replace(
      new RegExp(this.searchText, "g"),
      `<span style="color:#FE9500;">${this.searchText}</span>`
    );
    return result;
  }
  searchText = "";
  active = "0";
  currentPage2 = 5;
  page = {
    pageNum: 1,
    pageSize: 10
  };
  handleSizeChange(val) {
    this.page.pageSize = val;
    this.getQueryContentPage();
  }
  handleCurrentChange(val) {
    this.page.pageNum = val;
    this.getQueryContentPage();
  }
  newsClass = [
    {
      className: t("base.all"),
      classCode: "",
      contentSum: "",
      createTime: ""
    }
  ];
  queryList = [];
  contentDetail: any = {};
  resList = {};
  classCode = "";
  className = "";
  item: any = {};
  newsFlag = true;
  hoverActive = "";
  learnContentCode = "";
  created() {
    if (localStorage.getItem("isWhitespace")) {
      this.isWhitespace = JSON.parse(localStorage.getItem("isWhitespace"));
    }
    this.init();
    let query = this.$route.query as any;
    if (query.search) {
      this.searchText = query.search;
    }
    if (this.$route.query.class) {
      this.classCode = query.class;
      this.active = query.class;
      if (query.learnContentCode) {
        this.classCode = query.class;
        this.learnContentCode = query.learnContentCode;
        this.newsFlag = false;
        this.fixedFlag = true;
        this.getDetail();
      }
    } else {
      this.classCode = "0";
      this.active = "0";
    }
    if (this.$route.query.className) {
      this.className = query.className;
    }
  }
  packUp(val) {
    localStorage.setItem("isWhitespace", val);
    this.isWhitespace = val;
  }

  hoverMouse(index) {
    this.hoverActive = index;
  }
  async init() {
    const res = await this.queryLearnClassList({ pageNum: 1, pageSize: 999 });
    this.newsClass = [
      {
        className: t("base.all"),
        classCode: "0",
        contentSum: "",
        createTime: ""
      },
      ...res.data.list
    ];
    let item = res.data.list.find(v => v.classCode === this.classCode);
    if (item && item.childrenList && item.childrenList.length) {
      this.newsCategory = [{ className: t("base.all"), classCode: "" }, ...item.childrenList];
    } else {
      this.newsCategory = [{ className: t("base.all"), classCode: "" }];
    }
    if (!this.$route.query.learnContentCode) {
      this.getQueryContentPage();
    }
  }
  async getQueryContentPage() {
    let learnContentType = "";
    if (this.categoryActive) {
      learnContentType = this.categoryActive;
    } else {
      learnContentType = this.classCode === "0" ? "" : this.classCode;
    }
    let param = {
      searchKey: this.searchText,
      ...this.page,
      learnContentType
    };
    this.searchFlag = true;
    this.newsFlag = true;
    const res = await this.searchLearnContentSettingPage(param);
    for (let i = 0; i < res.data.list.length; i++) {
      res.data.list[i].learnContentTitle = this.filterKeyLight(res.data.list[i].learnContentTitle);
      res.data.list[i].learnContentAbstract = this.filterKeyLight(res.data.list[i].learnContentAbstract);
    }
    this.queryList = res.data.list;
    this.resList = res.data;
  }
  searchFlag = false;
  handelQuery() {
    this.getQueryContentPage();
    this.searchRouter();
  }
  searchRouter() {
    this.$router.push(
      `/study/online-study/?class=${this.classCode}&search=${this.searchText}&className=${this.className}`
    );
  }
  handelClass(item) {
    this.$router.push(
      `/study/online-study/?class=${item.classCode}&search=${this.searchText}&className=${item.className}`
    );
  }
  newsCategory: any = [{ className: t("base.all"), classCode: "" }];
  categoryActive: any = "";
  handelCategory(item) {
    this.categoryActive = item.classCode;
    this.getQueryContentPage();
  }
  async handelGetHtml(item) {
    console.log("[ item ]", item);
    if (item.connectedExternal === "true") {
      this.addReadNumber(item);
      window.open(item.externalUrl);
    } else {
      this.learnContentCode = item.learnContentCode;
      this.classCode = item.learnContentType;
      this.className = item.learnContentTypeDesc;
      let routeData = this.$router.resolve({
        path: `/study/online-study/?class=${this.classCode}&learnContentCode=${this.learnContentCode}&search=${this.searchText}&className=${this.className}`
      });
      window.open(routeData.href, "_blank");
    }
  }
  async getDetail() {
    const res = await this.getLearnContentTextDetail({ learnContentCode: this.learnContentCode });
    this.contentDetail = res.data;
  }
  async addReadNumber(item) {
    await this.getLearnContentTextDetail({ learnContentCode: item.learnContentCode });
    this.getQueryContentPage();
  }
  async praise() {
    this.$message.success(t("v210831.thank-you-for-feedback"));
    await this.likeContent({ learnContentCode: this.contentDetail.learnContentCode, like: !this.contentDetail.like });
    this.getDetail();
  }
  hidden() {
    this.newsFlag = true;
    this.handelClass({ classCode: this.classCode, className: this.className });
  }
  async saveCreateDeploy() {
    let params = {
      examPaperTempCode: this.contentDetail.examinationCode,
      learnContentCode: this.contentDetail.learnContentCode,
      remark: this.remark
    };
    console.log("[ this.contentDetail ]", this.contentDetail);
    const res = await this.signUp(params);
    if (res.success === true) {
      this.$message.success(t("v210831.registration-succeeded"));
      this.contentDetail.hasSignedUp = "true";
      this.contentDetail.signUpNumber = Number(this.contentDetail.signUpNumber) + 1;
      this.showPickingTips = false;
      this.getQueryContentPage();
    } else {
      this.$message.warning(t("v210831.registration-failed"));
    }
  }
}
